import { ReactNode } from "react";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import {
  Button,
  CheckSVG,
  CopyClipboardSVG,
  EditHollowSVG,
  visuallyHiddenStyles,
} from "@newsela/angelou";
import { CITATION_COPY_BUTTON_TEXT } from "../../../CitationAction.constant";
import {
  buttonsContainerCss,
  copyButtonCss,
} from "./CitationGeneratorBodyButtons.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

interface CitationGeneratorBodyButtonsProps {
  citation: ReactNode;
  copyButtonText: string;
  setCopyButtonText: (copyButtonText: string) => void;
  setShowEditForm: (showEditForm: boolean) => void;
}
const CitationGeneratorBodyButtons = ({
  citation,
  copyButtonText,
  setCopyButtonText,
  setShowEditForm,
}: CitationGeneratorBodyButtonsProps) => {
  const handleCopyToClipboard = () => {
    setCopyButtonText(CITATION_COPY_BUTTON_TEXT.copied);
    void navigator.clipboard.writeText(String(citation));
  };

  return (
    <div css={buttonsContainerCss}>
      <ButtonWithTrackEvent
        dataProps={{ "data-qa-selector": "citation-copy-button" }}
        onClick={handleCopyToClipboard}
        flavor={Button.flavors.muted}
        objectType={objectTypes.generatedTextAsset}
        actionName={actionNames.copy}
        icon={{
          SvgComponent:
            copyButtonText === CITATION_COPY_BUTTON_TEXT.default
              ? CopyClipboardSVG
              : CheckSVG,
          alignment: Button.iconAlignments.right,
        }}
        __cssFor={{ root: copyButtonCss }}
      >
        {copyButtonText}
      </ButtonWithTrackEvent>
      <ButtonWithTrackEvent
        dataProps={{ "data-qa-selector": "citation-edit-button" }}
        onClick={() => setShowEditForm(true)}
        flavor={Button.flavors.muted}
        objectType={objectTypes.generatedTextAsset}
        actionName={actionNames.start}
        icon={{
          SvgComponent: EditHollowSVG,
          alignment: Button.iconAlignments.right,
        }}
        __cssFor={{ root: copyButtonCss }}
      >
        Edit
      </ButtonWithTrackEvent>
      <div css={visuallyHiddenStyles} role="status">
        {copyButtonText === CITATION_COPY_BUTTON_TEXT.copied
          ? CITATION_COPY_BUTTON_TEXT.copied
          : ""}
      </div>
    </div>
  );
};

export default CitationGeneratorBodyButtons;
